export default __webpack_public_path__ + "static/media/loader.82260c40.svg";